class DebugClass {
  constructor(is_show = false) {
    this.is_show = is_show;
    this.base_style = 'border-radius:6px;padding:1px 4px;font-size:1.5em;color:white;';
  }

  log() {
    const style = this.base_style + 'background:#2c3e50;';
    this.is_show ? this.show(console.log, style, ...arguments) : '';
  }
  error() {
    const style = this.base_style + 'background:#e74c3c;';
    this.is_show ? this.show(console.error, style, ...arguments) : '';
  }
  warn() {
    const style = this.base_style + 'background:#e67e22;';
    this.is_show ? this.show(console.warn, style, ...arguments) : '';
  }
  show(...params) {
    const [callback, style, ...args] = params;
    callback('%c🛠', style, ...args);
  }
  pure() {
    this.is_show ? console.log(...arguments) : '';
  }
}

const debug = new DebugClass(process.env.NODE_ENV === 'development');

export { debug };
